module.exports = __webpack_public_path__ + "static/media/default_company.bb166114.svg";